import { createLogger } from './debug';

const { log, error: logError } = createLogger('address-validator');

const csrfToken =
    document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute('content') ?? '';

export async function validateAddress(
    {
      payload = {},
      endpoint= '/Address/validate',
      button = null,       // optional: a <button> element to disable/spin
      onSuccess,                 // fn(resultData: any)
      onError                    // fn(error: Error)
    }) {
    if (button) {
        button.disabled = true;
        button.dataset.origText = button.textContent;
        button.textContent = 'Validating\u2026';
    }

    try {
        log('POSTing to', endpoint, '| csrfToken present:', !!csrfToken);
        const resp = await fetch(endpoint, {
            method:  'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept':       'application/json',
                'X-CSRF-Token': csrfToken,
            },
            body: JSON.stringify(payload),
        });

        if (!resp.ok) {
            const err = new Error('Server rejected the validation request');
            err.status = resp.status;
            throw err;
        }

        const json = await resp.json();

        if (!json.success) {
            const error = new Error(json.error || 'Address could not be validated');
            error.isDisabled = json.error?.includes('currently disabled') || json.error?.includes('currently unavailable');
            error.international = !!json.international;
            error.rateLimited = json.reason === 'rate_limited';
            error.captchaPending = json.reason === 'captcha_pending';
            throw error;
        }

        if (!json.data?.validated_address) {
            throw new Error('Address could not be validated');
        }

        onSuccess(json.data);
    } catch (err) {
        logError(err);
        onError(err);
    } finally {
        if (button) {
            button.disabled = false;
            // Restore original text if it was changed to "Validating…"
            if (button.textContent === 'Validating…') {
                button.textContent = button.dataset.origText;
            }
        }
    }
}
